import { render, staticRenderFns } from "./LocationFaqs.vue?vue&type=template&id=cb7832b0&scoped=true&"
import script from "./LocationFaqs.vue?vue&type=script&lang=js&"
export * from "./LocationFaqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7832b0",
  null
  
)

export default component.exports